import React, { Fragment } from 'react';
import Head from 'next/head';
import BannerWithGraphic from '../../components/common/BannerWithGraphic';
import styles from '../../styles/modules/common/banner-graphic.module.scss';
import { GetProtectionPlanDetails } from '../../api/common-pages/index';
import { useRouter } from 'next/router';
import dynamic from "next/dynamic";
import ProtectionCardWithBanner from '../../components/commom-pages/ProtectionCardWithBanner'
import featureStyles from '../../styles/modules/common/features.module.scss';
import {trackPage} from "../../tracking/index";
import Config from '../../config';
import {getStaticPath} from '../../utils';
import { getPageViewData } from '../../utils/tracking';
import page_data from '../../data/page_data';
import Error404 from '../404';


const Blog = dynamic(()=> import("../../components/common/Blog"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const Faq = dynamic(()=> import("../../components/common/Faq"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const CrossSell = dynamic(()=> import("../../components/cross-sell/CrossSell"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const FeatureImageBanner = dynamic(()=> import("../../components/common/FeatureImageBanner"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const FeatureTwoRowComponent = dynamic(()=> import("../../components/common/FeatureTwoRowComponent"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const Testimonial = dynamic(()=> import("../../components/common/Testimonials"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const Fetcher = async (context:any) => {
  
  const planDetails = await GetProtectionPlanDetails({ category_slug: context.params.category_slug, page: 'extended-warranty-plans' })
  const page_details = page_data[`protection-plans/${context.params.category_slug}`]

  const data = {
    plans: planDetails?.data.plans || [],
    twoRowFeatures: planDetails?.data?.features?.twoRowFeatures || {},
    how_it_works: planDetails?.data?.features?.how_it_works || {},
    faqs: page_details?.faqs || [],
    blogs: page_details?.blogs || [],
    cross_sell: page_details?.cross_sell || [],
    testimonials: page_details?.testimonials || [],
    bannerImageData: page_details?.banner_config || [],
    meta_tag_data: page_details?.meta_tag || [],
    is_page_valid: page_details ? true : false
  }

  return data
  
}
interface PlanDetails {
    plans: {
        title: string,
        url: string,
        data: any
        device: string,
    }[],
    faqs: any[],
    blogs: any[],
    cross_sell: any[],
    testimonials: any[],
    bannerImageData: any,
    meta_tag_data: any,
    twoRowFeatures: any,
    how_it_works:any,
}

// #TODO: If getStaticProps are removed then will remove getStaticPaths also
// export async function getStaticPaths() {
//     const devices = await GetProtectionPlanDevices();
   
//     return {
//         paths: devices ? devices.data : [],
//         fallback: false
//     }
// }

export async function getServerSideProps(context: any) {
  const data = await Fetcher(context)
  return {
    props: { ...data, pageName: 'protection-plans' }
  }
}


const ProtectionPlanDetails = (props: PlanDetails) => {
    const router = useRouter();
    const device = props.plans[0] ? props.plans[0].device : 'device'
    const blogTitle = device;
    const BASE_URL = Config.BASE_URL;
    const OG_IMAGE = getStaticPath(props.bannerImageData?.og_image)
    var colomn = false;
    if (props.plans.length === 2) {
        colomn = true;
    }
    React.useEffect(()=>{
        trackPage("Protection Plan Common Page",{...getPageViewData()})
    },[])

    const cached_props:any = props
    return (
        <Fragment>
            {cached_props.is_page_valid ? 
            <>
              <Head>
                <title>{cached_props.meta_tag_data.tag_title}</title>
                <link rel="icon" href="/favicon.ico" />
                <meta name="description" content={cached_props.meta_tag_data.tag_description}></meta>
                <meta property="og:title" content={cached_props.meta_tag_data.tag_title}/>
                <meta property="og:description" content={cached_props.meta_tag_data.tag_description}/>
                <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
                <meta property="og:image" content={OG_IMAGE}/>
                <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
              </Head>
              <main key={`protection-plan-${router.asPath}`}>
                  <BannerWithGraphic key={`protection-plan-banner-${router.asPath}`} className={styles.protection} title={cached_props.bannerImageData.title} subtitle={cached_props.bannerImageData.subtitle} banner_img={cached_props.bannerImageData.image} isCommon={true} journeyType="PP"/>
                  <ProtectionCardWithBanner plans={cached_props.plans} colomn={colomn} router={router} />

                  <div className='odd-even-start-with-white'>

                    {cached_props.testimonials && cached_props.testimonials.length !==0 && <Testimonial testimonial={cached_props.testimonials} router={router}/>}
                    {cached_props.how_it_works && <FeatureImageBanner title={cached_props.how_it_works !== undefined ? cached_props.how_it_works.title : ''} withSubtitle={false} features={cached_props.how_it_works !== undefined ? cached_props.how_it_works.features : ''}  className={`${featureStyles.grey__neutral} ${featureStyles.how_to_enjoy_ac}`}isGreyBackground={false} isRoundShape={true} imageSizeClass={featureStyles.amc__circle_image}/>}
                    {cached_props.twoRowFeatures && <FeatureTwoRowComponent withSubtitle={false} features={cached_props.twoRowFeatures.rowFeatures ? cached_props.twoRowFeatures.rowFeatures : ''} className={`${featureStyles.grey__neutral}`} title={cached_props.twoRowFeatures.title ? cached_props.twoRowFeatures.title : ''} isGreyBackground={true} />}
                    {cached_props.blogs && cached_props.blogs.length !==0 && <Blog key="ac-blog" blog={cached_props.blogs?cached_props.blogs:[]} title={`Handpicked Blogs on ${blogTitle}`}/>}
                    {cached_props.faqs && cached_props.faqs.length !== 0 ? <Faq title="Frequently Asked Questions" questions={cached_props.faqs} className="faq-primary" /> : null}
                    {cached_props.cross_sell.length !== 0 ? (<CrossSell list={cached_props.cross_sell} router={router} />) : ''}
                    
                  </div>
              </main> 
              </>
            : <Error404/> }
        </Fragment>
    )
}

export default ProtectionPlanDetails;
